import styled from "styled-components";
import { MarginProps } from "styled-system";
import Box from "../Box";
import Tab from "../Tab";
import { Choice } from "../../types/commercial";
import { useTranslation } from "react-i18next";

const BoxCustom = styled(Box)<{ gap?: string; isBorded?: boolean }>`
  gap: ${(props) => props.gap};
  display: flex;
  border-bottom: ${(props) => (props?.isBorded ? " 1px solid #D9D9D9" : "")};
`;

type SLotTabsProps = {
  options: Choice[];
  RangeParam: string;
} & MarginProps;

const SLotTabs = ({ options, RangeParam }: SLotTabsProps) => {
  const {t} = useTranslation();
  return (
    <BoxCustom
      display="flex"
      justifyContent={"space-between"}
      alignItems="center"
      width={"100%"}
    >
      <Tab
        tabName={t('common.en_direct')}
        isActive={RangeParam === options[0]?.value}
        colorInactive={"#E5E5E5"}
        search={`?slot=${options[0]?.value}`}
        width="50%"
      />
      <Tab
        tabName={t('common.j_plus_1')}
        isActive={RangeParam === options[1]?.value}
        colorInactive={"#E5E5E5"}
        search={`?slot=${options[1]?.value}`}
        width="50%"
      />
    </BoxCustom>
  );
};

export default SLotTabs;
